import { layout } from '../../App.routing'

export const subscriberExclusive = (isRegional = false) => {
    function returnPromoCard(isRegional: boolean) {
        if (isRegional) {
            return layout.component({
                type: 'promotional-card',
                props: {
                    cardOrientation: {
                        defaultLayout: 'landscape',
                        alternativeLayoutOptions: {
                            breakpoint: 'md',
                            layout: 'portrait',
                        },
                    },
                    fixedRatio: '4:3',
                    hasBackground: true,
                    hasPadding: true,
                    mediaMode: 'edgeToEdge',
                    fontScale: 0.88,
                    showCTA: true,
                    verticalSpacing: 'md',
                    dataDefinitionArgs: {
                        type: 'promotional',
                        metadataKey: 'regional-subscriber-exclusive-card',
                        pageSize: 1,
                    },
                },
            })
        }

        return layout.component({
            type: 'curated-promotional-card',
            props: {
                fixedRatio: '16:9',
                hasBackground: true,
                hasPadding: true,
                mediaMode: 'edgeToEdge',
                fontScale: 1,
                dataDefinitionArgs: {
                    type: 'active-promotion',
                    promotionSlotId: 'homepage-position-1',
                },
                cardOrientation: {
                    defaultLayout: 'portrait',
                },
            },
        })
    }

    return layout.nestedComposition({
        type: 'janus',
        props: {
            layoutRatio: '1:3',
            stretchColumns: true,
            verticalSpacing: 'xl',
        },
        contentAreas: {
            left: [
                layout.component({
                    type: 'section-header',
                    props: {
                        heading: 'Promotional',
                        hasMargin: true,
                        invisibleHeaderBreakpoint: 'md',
                    },
                }),

                returnPromoCard(isRegional),
            ],
            right: [
                layout.component({
                    type: 'lima',
                    props: {
                        fixedRatios: ['16:9'],
                        intermediateColumns: 3,
                        finalColumns: 3,
                        hideByline: false,
                        hasBackground: true,
                        fontScale: 0.88,
                        cardOrientation: { type: 'Landscape-Portrait' },

                        sectionHeader: {
                            heading: 'Subscriber Exclusive',
                            headingUrl: '/features',
                            section: 'default',
                        },
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: 'subscriber-exclusive',
                            offset: 0,
                            pageSize: 3,
                        },
                    },
                }),
            ],
        },
    })
}
